module.exports = __webpack_public_path__ + "img/favicon.4abffd01.svg";